import { render, staticRenderFns } from "./paya-report.vue?vue&type=template&id=d234e87a"
import script from "./paya-report.vue?vue&type=script&lang=js"
export * from "./paya-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports